import EmblaCarousel, {
	EmblaCarouselType,
	EmblaOptionsType,
} from 'embla-carousel'
import ClassNames from 'embla-carousel-class-names'
import { UcoastEl } from '@/scripts/core/UcoastEl'
import { TsDOM as q } from '@/scripts/core/TsDOM'

export class PressQuoteCarousel extends UcoastEl {
	static htmlSelector = 'press-quote-carousel'

	private viewport?: HTMLElement
	private prevButton?: HTMLButtonElement
	private nextButton?: HTMLButtonElement
	private currentSlide?: HTMLElement
	private emblaApi?: EmblaCarouselType

	constructor() {
		super()

		this.viewport = q.os('.press-quote-carousel__viewport', this)
		this.prevButton = q.os<HTMLButtonElement>(
			'.press-quote-carousel__button--prev',
			this
		)
		this.nextButton = q.os<HTMLButtonElement>(
			'.press-quote-carousel__button--next',
			this
		)
		this.currentSlide = q.os('[data-current-slide]', this)
	}

	override connectedCallback() {
		super.connectedCallback()

		if (this.emblaApi) return
		if (!this.viewport || !this.prevButton || !this.nextButton) return

		const options: EmblaOptionsType = {
			align: 'center',
			containScroll: 'trimSnaps',
			dragFree: false,
			loop: true,
			slidesToScroll: 1,
		}

		try {
			this.emblaApi = EmblaCarousel(this.viewport, options, [ClassNames()])
		} catch (error) {
			console.error(error)
			return
		}

		this.prevButton.addEventListener('click', this.handlePrevious)
		this.nextButton.addEventListener('click', this.handleNext)

		this.emblaApi.on('init', this.updateControls)
		this.emblaApi.on('reInit', this.updateControls)
		this.emblaApi.on('select', this.updateControls)

		this.updateControls()
	}

	override disconnectedCallback() {
		super.disconnectedCallback()

		this.prevButton?.removeEventListener('click', this.handlePrevious)
		this.nextButton?.removeEventListener('click', this.handleNext)
		this.emblaApi?.destroy()
		this.emblaApi = undefined
	}

	private handlePrevious = () => {
		this.emblaApi?.scrollPrev()
	}

	private handleNext = () => {
		this.emblaApi?.scrollNext()
	}

	private updateControls = () => {
		if (!this.emblaApi) return

		const selectedSnap = this.emblaApi.selectedScrollSnap()

		if (this.currentSlide) {
			this.currentSlide.textContent = `${selectedSnap + 1}`
		}

		if (this.prevButton) {
			this.prevButton.disabled = false
		}

		if (this.nextButton) {
			this.nextButton.disabled = false
		}
	}
}
